import { useMemo } from 'react';

import { NumberPatternType, ValidationRules } from '@dreryk/react-common';
import { NumberInput } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import {
   MedicalDeviceOrderFistulaCountFormBeanPart,
   MedicalDeviceOrderFormBean,
   MedicalDeviceOrderFormRegister,
   MedicalDeviceOrderFormWatch,
} from '../medicalDeviceOrder.types';
import { isMedicalDeviceFieldRequired } from '../medicalDeviceOrder.utils';

type FistulaCountFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<MedicalDeviceOrderFistulaCountFormBeanPart>;
   readonly watch: MedicalDeviceOrderFormWatch;
};

const MIN_FISTULA_COUNT = 1;
const MAX_FISTULA_COUNT = 9;

export const FistulaCountField = (props: FistulaCountFieldProps): JSX.Element => {
   const required = isMedicalDeviceFieldRequired(props.watch, 'fistulaCount');
   const validationRules = useMemo(() => {
      const rules: ValidationRules<MedicalDeviceOrderFormBean> = {
         required: required,
      };
      if (!required) {
         rules.min = {
            value: MIN_FISTULA_COUNT,
            message: medicalDevicesTranslationKeys.fields.fistulaMinMaxValidationMessage,
         };
         rules.max = {
            value: MAX_FISTULA_COUNT,
            message: medicalDevicesTranslationKeys.fields.fistulaMinMaxValidationMessage,
         };
      }
      return rules;
   }, [required]);
   return (
      <NumberInput
         testId={'fistulaCount'}
         label={medicalDevicesTranslationKeys.fields.fistulaCount}
         controller={props.register('fistulaCount', validationRules)}
         max={MAX_FISTULA_COUNT}
         min={MIN_FISTULA_COUNT}
         defaultValue={required ? MIN_FISTULA_COUNT : undefined}
         // TODO: DREGAB-4872 Handle other patterns in combination with additional entitlements
         pattern={NumberPatternType.POSITIVE_INTEGER}
         precision={0}
      />
   );
};
